import { Box, Button, Typography } from "@mui/material";
import { useState, useRef } from "react";
import { SketchPicker } from "react-color";
import { useSelector, useDispatch } from "react-redux";
import { useOnClickOutside } from "usehooks-ts";
import { ColourType, Root } from "../../state/types";
import { updateQrColour } from "../../state/mainSlice";

const QrColour = () => {
    const dispatch = useDispatch();
    const [showColorPicker, setShowColorPicker] = useState(false);
    const pickerRef = useRef(null);

    const qrData = useSelector((state: Root) => state.qrData);

    const onChange = (val: string) => {
        dispatch(updateQrColour({ colourType: ColourType.QRCOLOUR, colourValue: val }));
    };

    useOnClickOutside(pickerRef, () => setShowColorPicker(false));

    return (
        <Box sx={{ marginTop: -2 }}>
            <Typography variant="body1">QR color:</Typography>
            <Box
                sx={{
                    width: 30,
                    height: 30,
                    backgroundColor: qrData.qrColour,
                    border: "1px solid #000",
                    cursor: "pointer",
                    display: "inline-block",
                }}
                onClick={() => setShowColorPicker(true)}
            />
            {showColorPicker && (
                <Box ref={pickerRef} sx={{ position: "absolute", zIndex: 2}}>
                    <SketchPicker
                        color={qrData.qrColour}
                        onChangeComplete={(color) => onChange(color.hex)}
                    />
                    <Button onClick={() => setShowColorPicker(false)} sx={{ marginTop: 1 }}>
                        Close
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default QrColour;
